<div [formGroup]="organizationForm">
  <!-- <canvas #confettiCanvas></canvas> -->
  <div class="flex flex-col gap-2">
    <mat-form-field class="fuse-mat-dense w-full" [subscriptSizing]="'dynamic'">
      <mat-label>Organization Name</mat-label>
      <mat-icon class="icon-size-5" [svgIcon]="'mat_outline:business'" matPrefix></mat-icon>
      <input formControlName="organizationName" matInput cdkFocusInitial>
      <mat-hint>Enter the name of your organization. This will be used to identify your account and personalize your experience throughout the platform.</mat-hint>
      <mat-error>Organization Name is required</mat-error>
    </mat-form-field>
    <tm-country-code-select [hint]="'It helps us to display dates and other information according to your organization’s regional standards'"></tm-country-code-select>
    <tm-time-zone-select hint="Select the industry that best represents your organisations’s focus. This will help us tailor our services and features to match your specific needs and goals."></tm-time-zone-select>
    <mat-form-field class="fuse-mat-dense w-full" [subscriptSizing]="'dynamic'">
      <mat-label>Select the industry</mat-label>
      <mat-select formControlName="industry">
        <mat-option [value]="industry.id" *ngFor="let industry of idustryList">{{industry.name}}</mat-option>
      </mat-select>
    </mat-form-field>
    <div class="flex flex-col mt-2">
      <button class="w-full sm:w-auto sm:ml-auto" [disabled]="organizationForm.invalid || (submitting$ | async)" color="primary" mat-raised-button
        (click)="organizationCreate()">
        <div class="flex items-center gap-2">
          <ng-container *ngIf="submitting$ | async" [ngTemplateOutlet]="spinner"></ng-container>
          <div>Complete Registration</div>
        </div>
      </button>
    </div>
  </div>
</div>

<ng-template #spinner>
  <mat-spinner [color]="'primary'" diameter="20"></mat-spinner>
</ng-template>